module.exports = __webpack_public_path__ + "img/LOGO-FACILISIMO-GRIS.98558284.png";